import React from "react";
import PlaceholderContainer from "./PlaceholderContainer";
import { StyleSheet, View } from "react-native";
import { Placeholder, PlaceholderLine, PlaceholderMedia } from 'placeholders/Placeholder'

const PlaceholderBuildingBar = ({ addTitle = true, addButton = false, containerStyle = {} }) => {
	
	return (
		<PlaceholderContainer style={ containerStyle }>
			<Placeholder>
				{ addTitle && (
					<PlaceholderLine
						width={ 20 }
					/>
				)}
				
				<PlaceholderMedia
					style={ styles.media }
				/>
				
				<View style={ styles.row }>
					<View
						style={ styles.content }>
						<PlaceholderLine
							width={ 90 }
						/>
						<PlaceholderLine
							width={ 70 }
						/>
					</View>
					
					{addButton && (
						<PlaceholderMedia
							style={ styles.button }
						/>
					)}
				</View>
			</Placeholder>
		</PlaceholderContainer>
	)
}

const styles = StyleSheet.create({
	media: { width: '100%', marginBottom: 5 },
	row: { flexDirection: 'row' },
	content: { flex: 1, marginRight: 20 },
	button: { justifyContent: 'flex-end' },
});

export default PlaceholderBuildingBar
